import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import {
  DRAFT_AGENCY_CHAT_DEFAULT_PANEL_WIDTH,
  DRAFT_AGENCY_CHAT_MAX_PANEL_WIDTH,
  DRAFT_AGENCY_CHAT_MIN_PANEL_WIDTH,
} from '../../constants/draft-agency-chat.constants'

export interface DraftAgencyChatState {
  isOpen: boolean
  panelWidth: number
  draftConversationId: string | null
  agencyId: string | null
}

const initialState: DraftAgencyChatState = {
  isOpen: false,
  panelWidth: DRAFT_AGENCY_CHAT_DEFAULT_PANEL_WIDTH,
  draftConversationId: null,
  agencyId: null,
}

export interface OpenDraftAgencyChatPayload {
  agencyId: string
  conversationId?: string
}

export interface SetPanelWidthPayload {
  width: number
}

export const draftAgencyChatSlice = createSlice({
  name: 'draftAgencyChat',
  initialState,
  reducers: {
    openDraftAgencyChat: (state, action: PayloadAction<OpenDraftAgencyChatPayload>) => {
      state.isOpen = true
      state.agencyId = action.payload.agencyId
      if (action.payload.conversationId) {
        state.draftConversationId = action.payload.conversationId
      }
    },

    closeDraftAgencyChat: (state) => {
      state.isOpen = false
    },

    toggleDraftAgencyChat: (state) => {
      state.isOpen = !state.isOpen
    },

    setDraftConversationId: (state, action: PayloadAction<string | null>) => {
      state.draftConversationId = action.payload
    },

    setDraftAgencyChatPanelWidth: (state, action: PayloadAction<SetPanelWidthPayload>) => {
      const clampedWidth = Math.max(
        DRAFT_AGENCY_CHAT_MIN_PANEL_WIDTH,
        Math.min(DRAFT_AGENCY_CHAT_MAX_PANEL_WIDTH, action.payload.width)
      )
      state.panelWidth = clampedWidth
    },

    resetDraftAgencyChat: () => initialState,
  },
})

export const {
  openDraftAgencyChat,
  closeDraftAgencyChat,
  toggleDraftAgencyChat,
  setDraftConversationId,
  setDraftAgencyChatPanelWidth,
  resetDraftAgencyChat,
} = draftAgencyChatSlice.actions

export const draftAgencyChatReducer = draftAgencyChatSlice.reducer
